// top-notifications-scroll.directive.ts
import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  Renderer2,
} from '@angular/core';

@Directive({
    selector: '[appTopNotificationsScroll]',
    standalone: false
})
export class TopNotificationsScrollDirective
  implements AfterViewInit, OnDestroy
{
  private _resizeObserver: ResizeObserver;
  public constructor(private el: ElementRef, private renderer: Renderer2) {}
  public ngAfterViewInit(): void {
    const mainContainer = this.el.nativeElement.closest('.main-container');
    if (!mainContainer) return;
    const messageList = mainContainer.querySelector('.message-list');
    if (messageList) {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
      this._resizeObserver = new ResizeObserver(() =>
        this.renderer.setStyle(
          messageList,
          'padding-top',
          `${this.el.nativeElement.offsetHeight}px`
        )
      );
      this._resizeObserver.observe(this.el.nativeElement);

      let scrollTop = (messageList as HTMLElement).scrollTop;
      this.renderer.setStyle(this.el.nativeElement, 'top', `${-scrollTop}px`);
      this.renderer.setStyle(
        messageList,
        'padding-top',
        `${this.el.nativeElement.offsetHeight}px`
      );
      this.renderer.listen(messageList, 'scroll', (event) => {
        scrollTop = (event.target as HTMLElement).scrollTop;
        this.renderer.setStyle(this.el.nativeElement, 'top', `${-scrollTop}px`);
      });
    }
  }

  public ngOnDestroy(): void {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }
}
